const styles = {
    legendContainer: {
        display: 'inline-block',
        float: 'left',
        width: 199
    },
    divContainer:{
        width: 210,
        height: 400,
        overflow: 'auto'
    },
    menuContainer:{
        width: 200,
        minHeight: 101,
        overflowY: 'auto'
    },
    legendWidth:{
        width: 180
    }
  };

  export default styles;


// WEBPACK FOOTER //
// ./src/services/maps/styles/speedLegendStyles.js